import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/site-admin/")({
  beforeLoad: () => {
    throw redirect({
      to: "/site-admin/dashboard",
      replace: true,
    });
  },
});
